import React, { useEffect, useState } from "react";
import adminApi from "../../services/adminApi";
import toast from "react-hot-toast";
import UsersTable from "./UsersTable";
import LoadingState from "../../components/Admin/LoadingState";
import "../../styles/Admin.css";

export default function AdminUsers() {
  const [users, setUsers] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    adminApi
      .get("/admin/users")
      .then((res) => setUsers(res.data.users))
      .catch(() => toast.error("Failed to load users"))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  if (users === null && loading) {
    return <LoadingState message="Loading users..." />;
  }

  return (
    <>
      <div className="admin-page-header">
        <h1 className="admin-page-title">User Management</h1>
        <p className="admin-page-subtitle">View and manage users, access their services</p>
      </div>

      <UsersTable users={users || []} loading={loading} onRefresh={load} />
    </>
  );
}


